import CioRioInfoModal from './CioRioInfoModal'
export default CioRioInfoModal
